'use strict';
// var language = localStorage.getItem('language') || 'zh-CN';
 require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
// var languageType = require('./languageCommon.js')
// var language = languageType.language;



require('./sensorsdata.js')
require('../home.css');
require('../less/common/searchForm.less');
require('../less/index.less');
require('../en.css');
// if (window.location.search.indexOf('lang=En') > -1) {
//     language = 'USA';
//     localStorage.setItem('language', 'USA')
// }
if (language == 'zh-CN') {
    $('body').removeClass('en')
} else {
    //如果是英文进入该页面，重定向到外文首页
    window.location.href='/indexForeign.html?locale='+language
    $('body').addClass('en')
}
var preS = require('./preSearch.js');
var preSearch = preS.preSearch
var Config = require('../config/config.js');
var url_prefix = Config.env[Config.scheme].prefix;
var apiPath = Config.env[Config.scheme].apiPath;
var aihuazhuUrl = Config.env[Config.scheme].aihuazhuUrl;
$("img").on('dragstart', function () {
    return false;
})

$('.commonHomePage').addClass('select')
$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
    $('.reservationCode').fadeOut(300);
    $('.reservation').css('opacity', 1);
});


$(".about1").on('mouseover', function () {
    $(".aboutLv").show();
})
$(".about1").on('mouseout', function () {
    $(".aboutLv").hide();
})
$(".brand1").on('mouseover', function () {
    $(".choiceBrand").show();
}).on('mouseout', function () {
    $(".choiceBrand").hide();
})
$('.language').on('mouseover', function () {
    $(".choicelanguage").show();
}).on('mouseout', function () {
    $(".choicelanguage").hide();
})
$('.choicelanguage a').eq(0).on('click', function () {
    console.log(window.location)
    window.location.href = window.location.origin+window.location.pathname+'?locale=zh-CN'
    localStorage.setItem('language', 'zh-CN');
    if (window.location.search.indexOf('lang=En') > -1) {
        window.location.href = '/'
        return
    }
    //window.location.reload();
})
$('.choicelanguage a').eq(1).on('click', function () {
    localStorage.setItem('language', 'USA');
    window.location.href = window.location.origin+window.location.pathname+'?locale=USA'
})
$('.choicelanguage a').eq(2).on('click', function () {
    localStorage.setItem('language', 'JP');
    window.location.href = window.location.origin+window.location.pathname+'?locale=JP'
    //window.location.reload();
})
$('.choicelanguage a').eq(3).on('click', function () {
    localStorage.setItem('language', 'KO');
    window.location.href = window.location.origin+window.location.pathname+'?locale=KO'
    //window.location.reload();
})
$('.choicelanguage a').eq(4).on('click',function(){
   localStorage.setItem('language','TH');
window.location.href = window.location.origin+window.location.pathname+'?locale=TH'
    //window.location.reload();
})
$('.choicelanguage a').eq(5).on('click',function(){
    localStorage.setItem('language','TH');
 window.location.href = window.location.origin+window.location.pathname+'?locale=YH'
     //window.location.reload();
 })
var sliderRowStep=0;
var $oImgs=$('.swiper_row .slider');
function autoMove(){
    sliderRowStep++;
    sliderRowStep>3?sliderRowStep=0:null;//当显示最后一张，下一次让outer.step变为0
    $oImgs.eq(sliderRowStep).fadeIn(2500).siblings().fadeOut(2500);
}
setInterval(autoMove,4000);


$(".submitInfo_submit").on("click", submitInfo)

function submitInfo() {
    if (!$(".submitInfo_name").val()) {
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputName[language]);
        $(".submitInfo_submit").off("click", submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo)
        }, 1500);
        return;
    }
    if ($(".submitInfo_name").val().length > 50) {
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputNameLong[language]);
        $(".submitInfo_submit").off("click", submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo)
        }, 1500);
        return;
    }
    if ($(".submitInfo_address").val().length > 50) {
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressLong[language]);
        $(".submitInfo_submit").off("click", submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo)
        }, 1500);
        return;
    }
    if (!(/^1[34578]\d{9}$/.test($(".submitInfo_phone").val()))) {
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputPhoneError[language]);
        $(".submitInfo_submit").off("click", submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo);
        }, 1500);
        return;
    }
    if (!$(".submitInfo_address").val()) {
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressError[language]);
        $(".submitInfo_submit").off("click", submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo)
        }, 1500);
        return;
    }
    $(".submitInfo_submit").off("click", submitInfo);
    sensors.track("formSubmit",{"name":$('.submitInfo_name').val(),'phone_number':$(".submitInfo_phone").val(),'address':$(".submitInfo_address").val(),'form_entrance':'PC首页'
});
    $.ajax({
        url: url_prefix + '/mng/api/pcms/league/create.json',
        type: 'POST',
        data: {
            name: $(".submitInfo_name").val(),
            mobile: $(".submitInfo_phone").val(),
            address: $(".submitInfo_address").val(),
            dataSource:1
        },
        dataType: 'json',
        timeout: 5000,
        success: function (res) {
            if (res.success) {
                $(".submitInfo_tips_1").html(commonCompanyCubmitSuccess[language]);
                $(".submitInfo_tips_1").show();
                $(".submitInfo_name").val("");
                $(".submitInfo_phone").val("");
                $(".submitInfo_address").val("");
                $(".submitInfo_input_joinUs").html(homePageSwiperFiveJoin[language])
                setTimeout(function () {
                    $(".submitInfo_tips_1").hide();
                    $(".submitInfo_submit").on("click", submitInfo);
                }, 1500);


            } else {
                $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
                $(".submitInfo_tips_1").show();
                setTimeout(function () {
                    $(".submitInfo_tips_1").hide();
                    $(".submitInfo_submit").on("click", submitInfo);
                }, 1500);
            }

        },
        error: function (error) {
            $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
            $(".submitInfo_tips_1").show();
            setTimeout(function () {
                $(".submitInfo_tips_1").hide();
                $(".submitInfo_submit").on("click", submitInfo);
            }, 1500);
            $(".submitInfo_submit").on("click", submitInfo);
        }
    });
}


//判断是否是IE浏览器，包括Edge浏览器
function IEVersion() {
    var isOpera = navigator.userAgent.indexOf("Opera") > -1;
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
    var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return "IE7";
        } else if (fIEVersion == 8) {
            return "IE8";
        } else if (fIEVersion == 9) {
            return "IE9";
        } else if (fIEVersion == 10) {
            return "IE10";
        } else if (fIEVersion == 11) {
            return "IE11";
        } else {
            return "0"
        }//IE版本过低
    } else if (isEdge) {
        return "Edge";
    } else {
        return "-1";//非IE
    }
}


function placeholderSupport() {
    return 'placeholder' in document.createElement('input');
}

function placeholder(target) {

    $(target).val($(target).attr("datavalue")).addClass("inp");
    $(target).focus(function () {
        if ($(this).val() == $(this).attr("datavalue")) {
            $(this).val("").removeClass("inp");
        }

    })
    $(target).blur(function () {
        if ($(this).val() == "" || $(this).val() == $(this).attr("datavalue")) {
            $(this).val($(target).attr("datavalue")).addClass("inp");
        }
    })
}

if (!placeholderSupport()) {

    placeholder(".submitInfo_name")
    placeholder(".submitInfo_phone")
    placeholder(".submitInfo_address")
    placeholder(".ipt")
}

var animateIndex = 0;
var timer2 = setInterval(function () {
    animateIndex++;
    if (animateIndex > 10) {
        animateIndex = 0;
    }
    $(".animate1").eq(animateIndex).addClass("animate2").siblings().removeClass("animate2");
}, 6000);

$(".animate").on("mouseover", function () {
    $(".animate1").removeClass("animate2")
    clearInterval(timer2)
})
$(".animate").on("mouseout", function () {
    $(".animate1").eq(animateIndex).addClass("animate2")
    timer2 = setInterval(function () {
        animateIndex++;
        if (animateIndex > 10) {
            animateIndex = 0;
        }
        $(".animate1").eq(animateIndex).addClass("animate2").siblings().removeClass("animate2");
    }, 6000);
})


$('.column_slider3_flower').on('click',function () {
    $('.column_slider3_flower .select').addClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');

    $(".column_slider3_flower").addClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $('.column_slider3_Banlan').removeClass('selcet_color');

    $('.column_slider_3_Info_floral').show();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').hide();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').hide();

    $('.column_slider_3_Info_arula').hide();
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").addClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")

});
$('.column_slider3_floral_lux').on('click',function () {
    $('.column_slider3_flower .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').addClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');

    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").addClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $('.column_slider3_Banlan').removeClass('selcet_color');

    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').show();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').hide();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').hide();

    $('.column_slider_3_Info_arula').hide();
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").addClass("column_slider3_container_floral_lux")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")

});
$('.column_slider3_suoxin').on('click',function () {
    $('.column_slider3_flower .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxin .select').addClass('select2');
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');



    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_sucha').show();
    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').hide();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').hide();


    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxin").addClass("selcet_color");
    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $(".column_slider3_Banlan").removeClass("selcet_color");


    $('.column_slider_3_Info_arula').hide();
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").addClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")

});
$('.column_slider3_vyluk').on('click',function () {
    $('.column_slider3_vyluk .select').addClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_floral .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');


    $(".column_slider3_vyluk").addClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $(".column_slider3_Banlan").removeClass("selcet_color");


    $('.column_slider_3_Info_vyluk').show();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').hide();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').hide();


    $('.column_slider_3_Info_arula').hide();
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").addClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")

});
$('.column_slider3_suoxingChoice').on('click',function () {
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_floral .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').addClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');


    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").addClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $(".column_slider3_Banlan").removeClass("selcet_color");


    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_suoxingChoice').show();
    $('.column_slider_3_Info_URBA').hide();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').hide();


    $('.column_slider_3_Info_arula').hide();
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").addClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")


});
$('.column_slider3_URBA').on('click',function () {
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_floral .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').addClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');


    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").addClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $(".column_slider3_Banlan").removeClass("selcet_color");


    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').show();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').hide();


    $('.column_slider_3_Info_arula').hide();
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").addClass("column_slider3_container_URBA")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")

});

$('.column_slider3_arula').on('click',function () {
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_floral .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_arula .select').addClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');


    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_arula").addClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_Banlan").removeClass("selcet_color");


    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').hide();

    $('.column_slider_3_Info_arula').show();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').hide();



    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").addClass("column_slider_3_Info_arula")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")

});

$('.column_slider3_BeU').on('click',function () {
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_floral .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_BeU .select').addClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_Banlan .select').removeClass('select2');


    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_BeU").addClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $(".column_slider3_Banlan").removeClass("selcet_color");


    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').hide();
    $('.column_slider_3_Info_BeU').show();
    $('.column_slider_3_Info_Banlan').hide();


    $('.column_slider_3_Info_arula').hide();
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").addClass("column_slider3_container_BeU")
    $(".column_slider3_container").removeClass("column_slider3_container_Banlan")

});

$('.column_slider3_Banlan').on('click',function () {
    $('.column_slider3_vyluk .select').removeClass('select2');
    $('.column_slider3_suoxin .select').removeClass('select2');
    $('.column_slider3_floral .select').removeClass('select2');
    $('.column_slider3_floral_lux .select').removeClass('select2');
    $('.column_slider3_suoxingChoice .select').removeClass('select2');
    $('.column_slider3_URBA .select').removeClass('select2');
    $('.column_slider3_arula .select').removeClass('select2');
    $('.column_slider3_BeU .select').removeClass('select2');
    $('.column_slider3_arula .select').addClass('select2');



    $(".column_slider3_vyluk").removeClass("selcet_color");
    $(".column_slider3_suoxin").removeClass("selcet_color");
    $(".column_slider3_flower").removeClass("selcet_color");
    $(".column_slider3_floral_lux").removeClass("selcet_color");
    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
    $(".column_slider3_URBA").removeClass("selcet_color");
    $(".column_slider3_arula").removeClass("selcet_color");
    $(".column_slider3_BeU").removeClass("selcet_color");
    $(".column_slider3_Banlan").addClass("selcet_color");


    $('.column_slider_3_Info_vyluk').hide();
    $('.column_slider_3_Info_sucha').hide();
    $('.column_slider_3_Info_floral').hide();
    $('.column_slider_3_Info_floral_lux').hide();
    $('.column_slider_3_Info_suoxingChoice').hide();
    $('.column_slider_3_Info_URBA').hide();

    $('.column_slider_3_Info_arula').hide();
    $('.column_slider_3_Info_BeU').hide();
    $('.column_slider_3_Info_Banlan').show();

    $(".column_slider3_container").removeClass("column_slider3_container_vyluk")
    $(".column_slider3_container").removeClass("column_slider3_container_sucha")
    $(".column_slider3_container").removeClass("column_slider3_container_floral")
    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice")
    $(".column_slider3_container").removeClass("column_slider3_container_URBA")
    $(".column_slider3_container").removeClass("column_slider_3_Info_arula")
    $(".column_slider3_container").removeClass("column_slider3_container_BeU")
    $(".column_slider3_container").addClass("column_slider3_container_Banlan")


});

$(function(){
    $.ajax({
        url:  apiPath+'/api/hotel/hot_dests_and_cities.json',
        type: 'GET',
        cache: false,
        data: {
            client:'app'
        },
        success: function(res) {
            if (res.success) {
                window.hotCityObj = res.data
                destination( 'inland');
            }
        }
    })
    preSearch({
        checkIn:$('input[data-selector="checkIn"]').val(),
        checkOut:$('input[data-selector="checkOut"]').val()
    },clickDestinationCallback);

    $('.member_btn a').click(function(){
        window.open(aihuazhuUrl+$(this).data('href'))
    })
})

// 目的地 弹窗
function destination(key) {
    $('[data-selector="destination"]').destination({
        data: hotCityObj,
        key: key,
        hot: true,
        mapKey: ['ABCD', 'EFGH', 'JKLM', 'NOPQRS', 'TUVWX', 'YZ'],
        clickCallBack: function (obj) {
            clickDestinationCallback(obj)
        }
    });
}

function clickDestinationCallback(obj){
    $('[name="regionId"]').val(obj.id);
    $('[name="regionName"]').val(obj.name);
    $('input[name="regionType"]').val(obj.type);
    destinationInitVal = obj.name;//默认显示的目的地的值
    var timeObj = getTime(obj.id, true, hotCityObj);
    setDatepickInit(timeObj);
}


$(document).on('submit', '[data-selector="search-hotel"]', function () {
    var cityId = $('input[name="regionId"]').val();
    var regionType = $('input[name="regionType"]').val();
    var startDay = $('input[data-selector="checkIn"]').val();
    var endDay = $('input[data-selector="checkOut"]').val();
    window.open(aihuazhuUrl+'/list/' + regionType + '/' + cityId+'?startDay='+startDay+'&endDay='+endDay);
    return false;
});



/** WEBPACK FOOTER **
 ** ./src/js/index.js
 **/